import React from 'react';

const ClientSearchBar = ({ selectedClient, onClientSelect }) => {
  return (
    <div className="w-full">
      <input
        type="text"
        placeholder="Rechercher un client parrain..."
        className="form-input w-full"
        disabled
      />
      <p className="text-xs text-gray-500 mt-1">Système de parrainage - En attente de données clients</p>
    </div>
  );
};

export default ClientSearchBar;
